import $ from 'jquery';
import Cookies from 'js-cookie';

let langBar;

const detectLanguage = function() {
    var language = navigator.languages && navigator.languages[0] || // Chrome / Firefox
           navigator.language ||   // All browsers
           navigator.userLanguage; // IE <= 10
    var current = window.App.locale.substr(0,2);
    var langChosen = Cookies.get('lang_chosen');
    language = language.substr(0,2).toLowerCase();
    if(langChosen) return;
    if(language == current || !window.App.languages.hasOwnProperty(language)) {
        Cookies.set('lang_chosen','auto',{ expires: 365 });
        return;
    }
    langBar.find('[data-lang-message]').html( window.App.languages[ language ].message );
    langBar.css('display','block');
}

const initLangBar = function() {
    langBar.on('click','[data-dismiss-lang]',function(event) {
        Cookies.set('lang_chosen','dismissed',{expires:365});
        langBar.fadeOut();
    });
    langBar.on('click','[data-accept-lang]',function(event) {
        Cookies.set('lang_chosen','accepted',{expires:365});
    });
}

const initLangLinks = function() {
    $(document).on('click','a[hreflang]',function(event) {
        if(!Cookies.get('lang_chosen')) {
            Cookies.set('lang_chosen','switched',{expires:365});
        }
    });
}

export default {
    init: function() {
        langBar = $('.language-bar');
        if(langBar.length && window.App.languages) {
            initLangBar();
            initLangLinks();
            detectLanguage();
        }
    }
}
